import { Component, HostListener, Input } from '@angular/core';
import { removeCharacters } from '@foxeet/utils/forms';
import { BaseFormComponent } from '../../../base-components';

@Component({
  selector: 'ui-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.scss'],
})
export class FormInputTextComponent extends BaseFormComponent<string> {
  @Input() type = 'text';
  @Input() showButton: boolean;
  @Input() buttonIcon: string;
  @Input() buttonColor: string;
  @Input() tooltip?: string;
  @Input() callback: (arg) => void;

  /**
   * Detecta cuando se pega texto (CTRL+V) en el textarea
   * @param event Evento de pegado
   */
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    // Prevenir el comportamiento predeterminado del navegador
    event.preventDefault();

    const input = event.target as HTMLInputElement;

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') ?? '';
    const cleanedText = removeCharacters(pastedText);

    const start = input.selectionStart ?? undefined;
    const end = input.selectionEnd ?? undefined;

    const originalValue = input.value;
    const newValue = originalValue.slice(0, start) + cleanedText + originalValue.slice(end);

    input.value = newValue;
    this.control.setValue(newValue);

    const newPos = start + cleanedText.length;
    input.setSelectionRange(newPos, newPos);
  }
}
